import { FC } from 'react'
import { IconButton, TableCell } from '@mui/material'
import styled from 'styled-components'
import { DownloadIcon, ReaderIcon } from '@radix-ui/react-icons'

import { spacingXXS } from 'Utils/styles/spacing'
import { useEmployerInfoContext } from 'Contexts/EmployerInfoContext'
import { useDownloadInvoice } from 'Hooks/api/employer/invoices/useDownloadInvoice'
import { EmployerAdminInvoice } from 'Utils/types/invoice'

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: ${spacingXXS};
`

type InvoiceActionsTableCellProps = {
  invoice: EmployerAdminInvoice
  setSelected: () => void
  toggleModal: () => void
}
export const InvoiceActionsTableCell: FC<InvoiceActionsTableCellProps> = ({
  invoice,
  setSelected,
  toggleModal
}) => {
  const {
    state: { employerId, employerInfo }
  } = useEmployerInfoContext()
  const { isLoading, mutate } = useDownloadInvoice()

  const handleDownloadInvoice = () => {
    if (employerId) {
      mutate({ employerId: employerId, invoice, employerName: employerInfo?.name || '' })
    }
  }

  const handleSelectOpenInvoiceDetails = () => {
    setSelected()
    toggleModal()
  }

  return (
    <TableCell>
      <Container>
        <IconButton
          aria-label="show invoice details"
          size="medium"
          onClick={handleSelectOpenInvoiceDetails}
        >
          <ReaderIcon />
        </IconButton>
        <IconButton
          aria-label="download invoice"
          size="medium"
          onClick={handleDownloadInvoice}
          disabled={isLoading}
        >
          <DownloadIcon />
        </IconButton>
      </Container>
    </TableCell>
  )
}
